/**
 *
 * @param {Object[]} fullList This will be the complete set of list as an object array, where the value property is the text
 * @param {string[]} selectedEntity This will be the selected object for the entity in the correct sort order, has only ids
 * @returns {Object[]} Returns the selected object, in the correct order with properties from the full list of object
 */

const getSortedObject = ({ fullList, selectedEntity }) => {
  // creates a way to know original sort order from settings
  const objectArray = selectedEntity.map((id, i) => {
    return { id: id, index: i };
  });
    
    //filter objects from full list of object array
    //creates new object with sortable index prop
    //sorts on new prop
    const foundObject = fullList
      .filter((obj) => selectedEntity.find((x) => x === obj.id))
      .map((obj) => {
        let target = {};
        let newList = Object.assign(target, obj);
        newList.originalIndex = objectArray.findIndex((x) => x.id === obj.id);
        return newList;
      })
      .sort((a, b) => a.originalIndex - b.originalIndex); //sort acs
  
    return foundObject;
  };
  
  export default getSortedObject;